import axios from "axios";
import { del, get, post, put } from "./api_helper";
import { s_get, s_post } from "./api_helper_staff";
import * as url from "./url_helper";
import showToast from "../common/Notification";

// API'S FOR STAFF PORTAL START
axios.defaults.auth = {
  username: process.env.REACT_APP_AUTH_USERNAME,
  password: process.env.REACT_APP_AUTH_PASSWORD,
};
// s_post --> post methond for staff portal apis

export const onUpdatingVehicleDetails = data => s_post(url.UPDATE_VEHICLE_DETAILS, data);
export const onSubmittingComment = data => s_post(url.SUBMIT_TIME_SHEET_COMMENT, data);
export const onGettingSupportWorkerTimeSheet = data => s_get(url.SUPPORT_WORKER_TIME_SHEET, data);
export const onRefiningNotesText = data => s_post(url.REFINE_NOTES_TEXT, data);
export const onSavingNoteByUser = data => s_post(url.PROGRESS_NOTE_SAVE, data);
export const onSubmittingHazard = data => s_post(url.EMP_SUBMIT_HAZARD, data);
export const onGettingEmpMedicines = data => s_post(url.EMP_MEDICINES_LIST, data);
export const onGettingMedPRN = data => s_post(url.MEDICATION_PRN_GET, data);
export const onSubmittingMedication = data => s_post(url.MEDICATION_SUBMIT_EMP, data);
export const onGettingTodaysMedications = data => s_post(url.TODAYS_MEDICATION_LIST, data);
export const onSubmittingMedReport = data => s_post(url.MED_REPORT_SUBMIT, data);
export const onGettingEmpMedication = (data, header) => s_post(url.EMP_MEDICATION_DETAILS, data, header);
export const onRemovingSwitchAccount = (data, header) => s_post(url.EMP_REMOVE_SWITCH_ACC, data, header);
export const onSwitchingAccount = (data, header) => s_post(url.ACCOUNT_SWITCH, data, header);
export const onGettingAccountList = (data, header) => s_post(url.SWITCHABLE_ACCOUNT_LIST, data, header);
export const onGettingRequestedOpenShift = data => s_post(url.REQUESTED_OPEN_SHIFT_LIST, data);
export const onCancelingOpenShift = data => s_post(url.CANCELING_OPEN_SHIFT, data);
export const onRequestingOpenShift = data => s_post(url.OPEN_SHIFT_REQUEST, data);
export const onEmpGetingOpenShift = data => s_post(url.EMP_OPEN_SHIFT_LIST, data);
export const onEmpAddingAvailability = data => s_post(url.EMP_AVAILABILITY_ADD, data);
export const onEmpUpdatingAvailability = data => s_post(url.EMP_UPDATE_AVAILABILITY, data);
export const onEmpGetingAvailability = data => s_post(url.EMP_AVAILABILITY_LIST, data);
export const onEmpEndingShift = data => s_post(url.EMP_SHIFT_END, data);
export const onEmpStartingShift = data => s_post(url.EMP_SHIFT_START, data);
export const onResendOtp = data => s_post(url.EMP_RESEND_OTP, data);
export const onEmpOtpVerify = data => s_post(url.POST_EMP_VERIFY_OTP, data);
export const PostEmpLoginUser = (data, header) => s_post(url.POST_EMP_LOGIN, data, header);
export const onEmpAddingFileToFolder = data => s_post(url.EMP_UPLOAD_FILE_TO_FOLDER, data);
export const onEmpFecthFiles = data => s_post(url.EMP_FETCH_MY_FILES, data);
export const onEmpFecthFolders = data => s_post(url.EMP_FETCH_MY_FOLDER, data);
export const fetchMyShifts = data => s_post(url.FETCH_MY_SHIFTS, data);
export const clickedOnDownlaod = data => s_post(url.CLICK_ON_TRAINING_DOC_DOWNLOAD, data);
export const trainingTermsConfirmation = data => s_post(url.TRAINING_TERMS_CONFIRMATION, data);
export const fetchPoliyForEmployee = data => s_post(url.EMPLOYEE_POLICIES, data);
export const submitIncidentForm = data => s_post(url.SUBMIT_EMPLOYEE_INCIDENT_FORM, data);
export const incidentFormQuestions = data => s_post(url.INCIDENT_FORM_QUESTIONS, data);
export const sendAttachedFileByEmployee = data => s_post(url.EMPLOYEE_ATTACHEMENTS, data);
export const staffgetEvents = data => s_post(url.ASSIGN_TASK_DATA_STAFF, data);
export const updateStaffProgressNote = data => s_post(url.UPDATE_PROGRESS_NOTE_BY_STAFF, data);
export const postIncidentReport = data => s_post(url.POST_INICIDENT_FORM, data);
export const postClockintime = data => s_post(url.POST_CLOCKIN_TIME_STAFF, data);
export const onConfirmingJob = data => s_post(url.POST_STAFF_ACTION_DATA, data);
export const postTimmingData = data => s_post(url.POST_TIMMINGS_DATA, data);
export const getProgressNotes = data => s_post(url.GET_PROGRESS_NOTE_BY_ID, data);
export const updateComment = data => s_post(url.UPDATE_ADD_COMMENT, data);
export const postForgetPwdStaff = data => s_post(url.STAFF_FORGET_PASS, data);
export const postForgetPwdStaffOtp = data => s_post(url.STAFF_FORGET_PASS_OTP, data);
export const staffTaskDetailsid = data => s_post(url.TASK_ID_DETAIL_STAFF, data);
export const partDetailsgetStaff = data => s_post(url.GET_PARTICIPANT_DETAILS, data);
export const getProgNotes = data => s_post(url.GET_PROGRESS_NOTES, data);
export const getSerItem = data => s_post(url.GET_SERVICE_ITEM_DETAILS, data);
export const setTaskTimeoutouted = data => s_post(url.TASK_TIME_OUT, data);
export const approveSubmit = data => s_post(url.APPROVE_SUBMIT, data);
export const log_out_staff = () => s_post(url.LOGOUT_STAFF, {});
export const employeeProfile = data => s_post(url.GET_EMPLOYEE_DOC, data);
export const uploadStaffCert = data => s_post(url.UPLOAD_STAFF_TRAINING_CERT, data);
export const uploadEmployeeReqDocs = data => s_post(url.UPLOAD_REQ_EMPLOYEE_DOCS, data);
export const getDocumentsStatus = data => s_post(url.GET_UPLOADED_DOC_STATUS, data);
export const getStaffTraining = data => s_post(url.GET_STAFF_TRAININGS_LIST, data);
export const awayPariticipant = data => s_post(url.AWAY_PARTICIPANT, data);
export const onSubmittingComplaintList = data => s_post(url.SUBMIT_EMPLOYEE_COMPLAINT_FORM, data);

// API'S FOR STAFF PORTAL END

// API'S FOR ADMIN PORTAL START

// forget pass with company name and email
const postFakeForgetPwd = async data => {
  // console.log(data)
  return await axios
    .post(url.FORGET_PASS_EMAIL_COMPANY, data)
    .then(response => {
      // console.log(response)
      if (response.status == 203) showToast("warning", "Authentication", "Not Valid Credentials");
      if (response.status == 200) return response.data;
      throw response.data;
    })
    .catch(err => {
      // console.log(err)
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = "Bad request";
            break;
        }
      }
      throw message;
    });
};

// SETTING PROFILE INFO
export const getUserInfo = data => post(url.USER_PROFILE_DATA, data);

// ---------- FOR ADMIN ROLE APIS -----------

// INTEGRATION
export const onSavingXeroxCode = data => post(url.SAVE_XEROX_CODE, data);

// LOCATION
export const onAddingVisitor = data => post(url.VISITOR_ADD, data);
export const onUpdatingContractor = data => post(url.UPDATE_CONTRACTOR, data);
export const onUpdatingService = data => post(url.UPDATE_SERVICE, data);
export const onUpdatingUpdating = data => post(url.UPDATE_LOCATION, data);
export const onRemovingVisitorFile = data => post(url.VISITOR_FILE_REMOVE, data);
export const onChangingContractorStatus = data => post(url.CONTRACTOR_STATUS_CHANGE, data);
export const onUpdatingVisitor = data => post(url.VISITOR_UPDATE, data);
export const onGettingVisitor = data => get(url.VISITOR_LIST, data);
export const onGettingLocationService = data => get(url.LOCATION_SERVICE_LIST, data);
export const onAddingLocationService = data => post(url.ADD_LOCATION_SERVICE, data);
export const onGettingContractorList = data => get(url.CONTRACTOR_LIST, data);
export const onAddingContractor = data => post(url.ADD_CONTRACTOR, data);

// PROGRESS NOTE TEMPLATE
export const onGetProgressNoteTemplates = () => get(url.PROGRESS_NOTE_TEMPLATES);
export const onCreateProgressNoteTemplates = data => post(url.PROGRESS_NOTE_CREATE, data);
export const onUpdateProgressNoteTemplates = data => post(url.PROGRESS_NOTE_UPDATE, data);
export const onRemoveProgressNoteTemplates = data => post(url.PROGRESS_NOTE_REMOVE, data);

// ROLE ACCESS
export const onGettingAccessTemplate = data => post(url.GET_ASSIGN_TEMPLATE, data);
export const onAssingAccess = data => post(url.ASSIGN_ACCESS, data);
export const onGetRoleAcces = data => post(url.ROLE_ACCESS_LIST, data);
export const onUpdateRoleAcces = data => post(url.UPDATE_ROLE_ACCESS, data);
export const onAddRoleAcces = data => post(url.ADD_ROLE_ACCESS, data);

// HAZARD REPORT
export const onGettingHazardReport = data => post(url.HAZARD_REPROTS_DATA, data);
export const onGettingReportsByLocation = data => get(url.HAZARD_REPROTS_BY_LOCATION, data);
export const onReviewingHazaredReport = data => post(url.REVIEW_HAZARD_REPROTS, data);
export const onSavingHazardEmila = data => post(url.HAZARD_EMAIL_SAVE, data);

// TEAM
export const onGettingTeamDashboardList = data => post(url.GET_TEAM_DASHBOARD_LIST, data);
export const onAppyTeamAction = data => post(url.TEAM_NOTIFY_ACTION, data);
export const onTeamAppyShiftStartAction = data => post(url.TEAM_START_SHIFT, data);
export const onTeamAppyShiftEndAction = data => post(url.TEAM_END_SHIFT, data);
export const onGettingTeamTask = data => post(url.GET_TEAM_TASK_LIST, data);
export const onGettingTeamTaskDetail = data => post(url.TASK_DETAILS_TEAM, data);
export const onEnteringTeamNotes = data => post(url.ENTER_TEAM_NOTES, data);
export const onSendingFilesForTeamTask = data => post(url.SEND_FILES_FOR_TASK, data);

// BULK BILLING
export const onGettingBulkBills = data => post(url.GET_BULK_BILLES, data);

// TEMPLATES
export const onDeletingTemplateList = data => post(url.TEMPLATE_DELETE, data);
export const onAddingTemplateList = data => post(url.TEMPLATE_ADD, data);
export const onGettingTemplateList = data => post(url.TEMPLATE_GET, data);

// PRESCRIBER
export const onDeletingPrescriber = data => post(url.PRESCRIBER_DELETE, data);
export const onUpdatingPrescriber = data => post(url.PRESCRIBER_UPDATE, data);
export const onAddingPrescriber = data => post(url.PRESCRIBER_ADD, data);
export const onGettingPrescribers = data => post(url.PRESCRIBER_LIST, data);
export const onGettingTaskPrescriberList = data => post(url.PRESCRIBER_LIST_FOR_TASK, data);

// MEDICATION
export const onMedicationCategoryList = data => post(url.MEDICATION_CATEGORIES_LIST, data);
export const onCreatingCategory = data => post(url.CREATE_CATEGORY_MEDICINE, data);
export const onUpdatePartMed = data => post(url.UPDATE_PART_MED, data);
export const onGettingMedicines = data => post(url.CATEGORY_MEDICINES_LIST, data);
export const onAddingMedicine = data => post(url.CREATE_MEDICINE, data);
export const onUpdatingMedicine = data => post(url.UPDATE_MEDICINE, data);
export const onDeletingMedicine = data => post(url.DELETE_MEDICINE, data);
export const onGettingMedDetails = data => post(url.MEDICINE_DETAILS, data);
export const onGettingMedDropList = data => post(url.MED_DROP_DOWN_LIST, data);
export const onGettingTaskMedDetail = data => post(url.TASK_PART_MED_DETAILS, data);
export const onGettingPartMedDetails = data => post(url.PARTICIPANT_MED_DETAILS, data);
export const onSavingPartMedDetails = data => post(url.SAVE_PARTICIPANT_MED_DETAILS, data);
export const onDeletingMedDoc = data => post(url.MED_DOC_DELETE, data);
export const onRemovingPartMed = data => post(url.PART_MED_REMOVE, data);
export const onUpdatingPartMedList = data => post(url.UPDATE_MED_PART_LIST, data);
export const onGettingTaskMedReport = data => post(url.MEDICATION_REPORT_TASK, data);
export const onAddingNewPartMed = data => post(url.PARTICIPANT_MED_LIST_ADD, data);
export const onGettingPartMedREport = data => post(url.PARTICIPANT_MEDICATION_REPORT, data);
export const onGettingPartMedicineLog = data => post(url.PART_MEDICINE_LOG_GET, data);
export const onGettingMedicationLog = data => post(url.MEDICATION_LOG_GET, data);

// ADMINS
export const onGettingAdminsList = data => post(url.LIST_ADMINS, data);

// SWTICH ACCOUNT
export const onGettingSwitchableAccs = (data, header) => post(url.SWITCHABLE_ACCOUNTS_LIST_ADMIN, data, true, header);
export const onSwitchingAdminAccount = (data, header) => post(url.SWITCHABLE_ACCOUNTS_ADMIN, data, true, header);
export const onRemovingAdminSwitchAcc = (data, header) => post(url.SWITCHABLE_ACC_ADMIN_REMOVE, data, true, header);
export const onAddingAdminSwitch = (data, header) => post(url.ADD_SWITCH_ACCOUNT_ADMIN, data, true, header);

// LOGIN
export const onLoginSuperAdmin = data => post(url.SUPER_ADMIN_LOGIN, data);
export const onLoggingReports = data => post(url.LOGIN_REPORTS, data);
export const onAdminLogin = (data, header) => post(url.ADMIN_LOGIN, data, true, header);
export const onAdminResendOtp = data => post(url.ADMIN_RESEND_OTP, data);
export const onOtpVerify = (data, header) => post(url.OTP_VERIFY, data, true, header);

// CHAT GPT
export const onApprovingReport = data => post(url.APPROVE_REPORT, data);
export const onGeneratingReport = data => post(url.REPORT_GENERATE, data);
export const onRefiningText = data => post(url.TEXT_REFINING, data);
export const onStoringRefinedText = data => post(url.STORE_OPEN_AI_TEXT, data);
export const onUpdatingOpenAiReport = data => post(url.OPEN_AI_REPORT_UPDATE, data);
export const onDeletingOpenAiReport = data => post(url.OPEN_AI_REPORT_DELETE, data);
export const onGettingRefinedTest = data => post(url.OPEN_AI_PROGRESS_NOTES, data);
export const onGettingReportLogs = data => post(url.OPEN_AI_REPORT_LOGS, data);
export const onGettingReportAttchList = data => post(url.REPORT_ATTACH_LIST, data);
export const onSavingReportAttachList = data => post(url.SAVE_ATTACH_REPORT_LIST, data);
export const onDeletingReportAttach = data => post(url.DELETE_ATTACH_REPORT, data);
export const onGettingReportDetail = data => post(url.PARTICIPANT_TASK_REPORT, data);

// SUPER ADMIN
export const onUpdatingWorkspaceUserDetails = data => post(url.SUPERADMIN_MANAGER_UPDATE, data);
export const onUpdatingWorkspaceDetails = data => post(url.WORKSPACE_DETAILS_UPDATE, data);
export const onGettingWorkspaceDetails = data => post(url.WORKSPACE_DETAILS, data);
export const getAdminList = () => get(url.GET_ADMIN);
export const postAddAdmin = data => post(url.POST_ADD_ADMIN, data);
export const postDeleteAdmin = data => post(url.DELETE_ADMIN, data);
export const postAddManager = data => post(url.POST_ADD_MANAGER, data);
export const onDeletingWorkspaceUser = data => post(url.WORKSPACE_USER_DELETE, data);
export const onTogglingAccountStatus = data => post(url.ADMIN_ACCOUNT_STATUS_TOGGLE, data);

// NOTICE BOARD
export const onDeletingSlide = data => post(url.NOTICE_BOARD_SLIDE_DELETE, data);
export const onCheckingBoardActivity = (data, header) => post(url.CHECK_BOARD_ACTIVE, data, true, header);
export const onResetingBoardPassword = data => post(url.NOTICE_BOARD_PASSWORD_RESET, data);
export const onUpdatingSlide = data => post(url.NOTICE_BOARD_SLIDE_UPDATE, data);
export const onLoggingNoticeBoard = data => post(url.NOTICE_BOARD_LOGIN, data, false);
export const onAddingSlide = data => post(url.ADD_BOARD_SLIDE, data);
export const onGettingBoardSlides = (data, header) => post(url.FETCH_BOARD_SLIDES, data, true, header);
export const onGettingBoadsList = data => post(url.BOARDS_LIST, data);
export const onCreatingBoard = data => post(url.CREATING_NOTICE_BOARD, data);
export const onDeletingBoard = data => post(url.DELETE_NOTICE_BOARD, data);

// TASK
export const onGettingLogs = data => post(url.GET_TASK_LOGS, data);
export const onRatingTask = data => post(url.RATE_TASK_NOTES, data);
export const onSendTaskRateEmail = data => post(url.SEND_RATE_TASK_EMAIL, data);

// SHIFT
export const shiftDelete = data => post(url.DELETE_SHIFT, data);
export const shiftUpdate = data => post(url.SHIFT_UPDATE, data);
export const fetchShifts = data => post(url.FETCH_SHIFTS_LIST, data);
export const AddShift = data => post(url.ADD_EMPLOYEE_SHIFT, data);
export const onGettingShiftLogs = data => post(url.GET_SHIFT_LOGS, data);
export const onGettingShiftReport = data => post(url.EXPORT_SHIFT_REPORT, data);
export const onCancellingShift = data => post(url.CANCEL_SHIFT_ADMIN, data);

// EMPLOYEE
export const onCopyingEmpProfile = data => post(url.EMPLOYEE_PROFILE_COPY, data);
export const onGeneratingTimeSheet = data => post(url.GENERATE_TIME_SHEET, data);
export const onGettingTimeSheetList = data => post(url.GET_ADMIN_TIMESHEET_LIST, data);
export const onSendingTimeSheet = data => post(url.SEND_TIME_SHEET_TO_SUPPORT_WORKER, data);
export const onReSubmittingTimeSheet = data => post(url.RE_SUBMIT_TIME_SHEET, data);
export const onRemovingTimeSheet = data => post(url.REMOVE_TIME_SHEET, data);
export const onGetEmployeeRatingReport = data => get(url.GET_EMPLOYEE_RATING_REPORT, data);
export const onRemovingTrainingDocs = data => post(url.DELETE_TRAINING_CERTIFICATE, data);

// EMAIL
export const onGetStoredEmails = data => post(url.GETING_STORED_EMAILS, data);
export const onGettingAddressBookList = data => post(url.ADDRESS_BOOK_LIST, data);
export const onRemovingEmail = data => post(url.ADDRESS_BOOK_REMOVE_EMAIL, data);

// PARTICIPANT
export const onAddingStatusRemark = data => post(url.ADD_STATUS_REMARK, data);
export const onGettingParticipantStatusLog = data => post(url.PARTICIPANT_STATUS_LOG, data);
export const onGettingParticipantDetailsForTask = data => post(url.PARTICIPANT_DETAILS_FOR_TASK, data);
export const onGettingParticipantAssignees = data => post(url.PARTICIPANTS_ASSIGNEES, data);
export const updateTaskStatus = data => post(url.CHANGE_TASK_STATUS, data);
export const onDeletingPartDescription = data => post(url.DELETING_PARTICIPANT_DISCRIPTION, data);
export const onDeletingDocument = data => post(url.DELETING_PARTICIPANT_DOCUMENT, data);
export const onRenamingFolder = data => post(url.FOLDER_RENAME, data);
export const checkUserValidity = data => post(url.USER_VALIDITY, data);
export const onDeletingStaffDocument = data => post(url.STAFF_DOC_DELETE, data);
export const onGetAvailability = data => post(url.GET_MY_AVAILABILITY, data);
export const onUpdatingOpenShifts = data => post(url.OPEN_SHIFT_UPDATE, data);
export const onGettingShiftRequestList = data => post(url.OPEN_SHIFT_REQUESTS, data);
export const onDeletingOpenShift = data => post(url.OPEN_SHIFT_DELETE, data);
export const onAcceptingShiftRequest = data => post(url.SHIFT_REQUEST_ACCEPT, data);
export const onAddingOpenShifts = data => post(url.OPEN_SHIFT_ADD, data);
export const onGettingOpenShifts = data => post(url.OPEN_SHIFT_LIST, data);
export const onAddServiceRecordFile = data => post(url.ADD_FILE_SERVICE_RECORD_BY_ID, data);
export const onDelServiceRecordFile = data => post(url.DELETE_FILE_SERVICE_RECORD_BY_ID, data);
export const onGettingServiceLogs = data => post(url.SERVICE_RECORD_LOGS, data);
export const onGetServiceListDetails = data => post(url.GET_SERVICE_RECORD_BY_ID, data);
export const onUpdatingServiceRecord = data => post(url.UPDATING_SERVICE_RECORD, data);
export const onDeletingServiceRecord = data => post(url.DELETING_SERVICE_RECORD, data);
export const onAddingServiceRecord = data => post(url.ADDING_SERVICE_RECORD, data);
export const onGetServiceList = data => post(url.SERVICE_RECORD_LIST, data);

export const onDeleteFolder = data => post(url.DELETE_USER_FOLDER, data);
export const onUpdatingFolderPermission = data => post(url.UPDATING_FOLDER_PERMISSION, data);
export const onRemovingFolderUser = data => post(url.REMOVING_FOLDER_USER, data);
export const onAssignedMembersFetch = data => post(url.FOLDER_ASSIGNED_MEMBERS, data);
export const onAssignFolders = data => post(url.ASSIGNING_FOLDERS, data);
export const onDeleteFolderFiles = data => post(url.DELETE_FOLDER_DOCS, data);
export const onAddingFileToFolder = data => post(url.UPLOAD_FILE_TO_FOLDER, data);
export const onFecthFiles = data => post(url.FETCH_MY_FILES, data);
export const onFecthFolders = data => post(url.FETCH_MY_FOLDER, data);
export const onCreatingFolder = data => post(url.CREATE_MY_FOLDER, data);
export const onAddingEmailSign = data => post(url.EMAIL_SIGN_ADD, data);
export const onFreeEmailNotification = data => post(url.FREE_EMAIL_NOTIFICATIONS, data);
export const onFreeNotifications = data => post(url.FREE_MY_NOTIFICATIONS, data);
export const fetchNotifications = data => post(url.GET_NOTIFICATIONS, data);
export const onReadMail = data => post(url.MAIL_READ, data);
export const getInboxMails = data => post(url.GET_INBOX_MAILS, data);
export const sendEmailToUser = data => post(url.SEND_EMAIL, data);
export const replyEmailToUser = data => post(url.REPLY_EMAIL, data);
export const fetchParticipantMails = data => post(url.PARTICIPANT_EMAIL_FETCH, data);

export const locationSkip = data => post(url.LOCATION_SKIP, data);
export const adminLogin = data => post(url.MANAGER_TO_ADMIN_LOGIN, data);
export const managerLogin = data => post(url.MANAGER_LOGIN, data);
export const locationDelete = data => post(url.LOCATION_DELETE, data);
export const updateManagerData = data => post(url.MANAGER_UPDATE, data);
export const fetchEmployeeByLocationList = data => post(url.EMPLOYEE_BY_LOCATION_LIST, data);
export const fetchParticipantByLocationList = data => post(url.PARTICIPANT_BY_LOCATION_LIST, data);
export const fetchManagerDetails = data => post(url.GET_DETAILS_MANGER, data);
export const locationAssigning = data => post(url.ASSIGNING_LOCATIONS, data);
export const addLocations = data => post(url.ADDING_LOCATIONS, data);
export const fetchLocationList = data => post(url.FETCH_LOCATIONS, data);
export const getAllLocations = data => post(url.ALL_AVAILABLE_LOCATION_LIST, data);
export const fetchManagerList = data => post(url.FETCH_MANAGERS, data);
export const onDeletingTaskDocs = data => post(url.TASK_DOCUMENT_DELETE, data);
export const fetchParticipants = data => post(url.FETCH_PARTICIPANT_LOCATION, data);

// privacy policy page
export const onGettingPolicyList = data => post(url.PRIVACY_POLICY_LIST, data);
export const onAddingPolicy = data => post(url.UPLOAD_PRIVACY_POLICY_DOC, data);
export const onDeletingPolicy = data => post(url.DELETE_PRIVACY_POLICY_DOC, data);

// for risk Assessment page
export const onUpdatingRiskAssessment = data => post(url.RISK_ASSESSMENT_STATUS_UPDATE, data);
export const onDeletingRiskAssessment = data => post(url.RISK_ASSESSMENT_LIST_DELETE, data);
export const onGettingRiskAssessmentList = data => post(url.RISK_ASSESSMENT_LIST, data);
export const onAddingRiskAssessment = data => post(url.ADD_NEW_RISK_ASSESSMENT_FORM, data);

// for incident form page
export const updateIncidentQuesOrder = data => post(url.ARRANGE_INCIDENT_QUES_ORDER, data);
export const onGettingIncidentLogs = data => post(url.LOGS_INCIDENT_REPORT, data);
export const sendEmailForIncident = data => post(url.SEND_EMAIL_FOR_INCIDENT_REPORT, data);
export const getIncidentFormsOld = data => post(url.FETCH_OLD_INCIDENT_FORM_LIST, data);
export const getIncidentFormsData = data => post(url.FETCH_ALL_INICIDENT_FORM_DATA, data);
export const submitReviewedIncidentForm = data => post(url.ADMIN_REVIEW_INCIDENT_FORM, data);
export const reviewIncidentForm = data => post(url.REVIEW_INCIDENT_FORM, data);
export const updateAdminIncidentFormQues = data => post(url.INICIDENT_FORM_QUES_UPDATE, data);
export const removeIncidentQues = data => post(url.DELETE_QUES_INCIDENT, data);
export const getAddedIncidentForms = data => post(url.GET_ADDED_INCIDENT_FORM_QUESTIONS, data);

// for rating dashboard

export const getRatedDashboardTask = data => get(url.GET_EMPLOYEE_RATING_DASHBOARD_TASK, data);

// src/helpers/fakebackend_helper.js
// export const getRatedDashboardTask = (data) => {
//   const { from_date_time, to_date_time, task_limit, task_duration_limit } = data;
//   return api.post('/rating_module/staff_performance_stats', {
//     from_date_time,
//     to_date_time,
//     task_limit,
//     task_duration_limit
//   });
// };

// for complaint form page
export const updateComplaintQuesOrder = data => post(url.ARRANGE_COMPLAINT_QUES_ORDER, data);
export const AddComplaintFormQuestion = data => post(url.ADD_COMPLAINT_QUESTION, data);
export const GetAddedQuestion = data => get(url.GET_ADDED_COMPLAINT_QUESTION, data);
export const DeleteComplaintQuestion = data => post(url.DELETE_COMPLAINT_QUESTION, data);
export const EditComplaintQuestion = data => post(url.EDIT_COMPLAINT_QUESTION, data);
export const getEmployeeComplaintForm = data => post(url.GET_EMPLOYEE_COMPLAINT_FORM, data);
export const onGettingComplaintList = data => get(url.GET_COMPLAINT_REGISTER, data);
export const onGettingComplaintDetail = data => get(url.GET_COMPLAINT_FORM_DETAIL, data);
export const onGettingComplaintPreview = data => get(url.PREVIEW_COMPLAINT_FORM, data);
export const onReviewingComplaintForm = data => post(url.REVIEW_COMPLAINT_FORM, data);

// For Funding Page

export const onGettingFundingReport = data => post(url.GET_PARTICIPANT_FUNDING, data);
// For training page
export const onAssigningTraining = data => post(url.TRAINING_ASSIGN, data);
export const onDeletingTraining = data => post(url.DELETE_TRAINING_LINK, data);
export const onUpdatingTraining = data => post(url.UPDATE_TRAINING_LINK, data);
export const onGettingTraining = data => post(url.GET_TRAINING, data);
export const onAddingTraining = data => post(url.ADD_NEW_TRAINING, data);

// for vehicle page
export const onGetVehiclesList = data => post(url.VEHICLE_LIST, data);
export const onDeletingVehicle = data => post(url.DELETE_VEHICLE, data);
export const onAddVehicle = data => post(url.ADD_VEHICLE, data);
export const onAddVehicleFile = data => post(url.ADDING_VEHICLE_FILE, data);
export const onDeleteVehicleFile = data => post(url.DELETING_VEHICLE_FILE, data);
export const onGettingVehicleDetails = data => post(url.VEHICLE_DETAILS, data);
export const onUpdateVehicle = data => post(url.VEHICLE_UPDATE, data);
export const onGettingVehicleHistory = data => post(url.VEHICLE_TRAVEL_HISTORY, data);
export const onGettingVehicleLogs = data => post(url.VEHICLE_LOGS, data);

export const onGetNdisGoal = data => get(url.GET_MYNDIS_GOAL, data);

// expired employee's documents
export const employeesExpDocsList = data => post(url.EXP_DOCS_LIST, data);
// nofity employee for documents
export const notifyEmployeeForDocs = data => post(url.NOTIFY_EMPLOYEE_DOCS, data);
// get employee token
export const getTokenEmployee = data => post(url.EMPLOYEE_TOKEN, data);
// get approve employee uploaded docs
export const employeeDocApproval = data => post(url.EMPLOYEE_DOC_APPROVAL, data);
export const employeeVehicleDocApproval = data => post(url.EMPLOYEE_VEHICLE_DOC_APPROVAL, data);
// get employee profile documents
export const employeeProfileDocs = data => post(url.EMPLOYEE_PROFILE_DOCUMENTS, data);
// get vehicle history
// notes by admin
export const progressNotesByAdmin = data => post(url.PROGRESS_NOTES_BY_ADMIN, data);
// update incident form
export const updateAdminIncidentForm = data => post(url.UPDATE_INCIDENT_FORM_ADMIN, data);
// get invoice details
export const getInvoiceDetail = data => post(url.GET_INVOICE_DETAILS_DATA, data);
// GET INVOICE DATA
export const getInvoicesList = data => post(url.GET_INVOICE_LIST_DATA, data);
// SEND UPDATED INVOICE DATA
export const sendInvoiceData = data => post(url.SEND_DATA_INVOICE, data);
// CHANGE PARTICIPANT'S STATE
export const changePartState = data => post(url.CHANGE_PART_STATE, data);
// CHANGE STAFF'S STATE
export const changeStaffState = data => post(url.CHANGE_STAFF_STATE, data);
// EDIT VEHICLE DETAILS ADMIN SIDE
export const editAdminVehicleDetails = data => post(url.EDIT_VEHICLE_DETAILS_ADMIN, data);
// CLOCK IN RESTRICTION ON STAFF
export const clockInRestrictionApi = data => post(url.CLOCKIN_RESTRICTION, data);
// DELETE TASK DESCRIPTION
export const deleteTaskDesc = data => post(url.DELETE_TASK_DESCRIPTION, data);
// DELETE TASK DESCRIPTION
export const updateTaskDesc = data => post(url.UPDATE_TASK_DESCRIPTION, data);
// UPLOAD INCIDENT FORM BY ADMIN
export const uploadAdminIncidentForm = data => post(url.ADMIN_UPLOAD_INCIDENT_FORM, data);
// GET INVOICES
export const getInvoices = data => post(url.GET_INVOICES, data);
// DELETE MULTIPLE TASKS
export const deleteMultipleTasks = data => post(url.DELETE_MULTIPLE_TASKS, data);
// INSERT STAFF ACTION TIMMING
export const insertStaffActionTime = data => post(url.INSERT_STAFF_TIMMINGS, data);
// UPDATE STAFF ACTION TIMMING
export const updateStaffActionTime = data => post(url.UPDATE_STAFF_TIMMINGS, data);
// EDIT COMPANY NAME
export const editCompanyProfile = data => post(url.EDIT_COMPANY_PROFILE, data);
// LIST FOR REGISTER PAGE
export const getIncidentFormsList = data => post(url.GET_INCIDENT_FORMS_LIST, data);
// APPROVE TASK TO STAFF
export const approveTaskToStaff = data => post(url.APPROVE_TASK, data);
const postProfile = data => post(url.POST_EDIT_PROFILE, data);
export const postFakeForgetPwdwithOtp = (data, headers) => post(url.FORGET_PASS_OTP, data, true, headers);
// Get Vehicle list

// Delete Vehicle
// Get Vehicle Details
// Update Vehicle details
// Add Vehicle
//POST COMMENTS
export const postComment = data => post(url.POST_ADD_COMMENT, data);
export const updateAdminNote = data => post(url.UPDATE_ADMIN_NOTE, data);
//POST TIME ZONE
export const postUserTimezone = data => post(url.POST_TIME_ZONE, data);
// GET DROP DOWN LIST DATA
export const getDropDownData = () => get(url.GET_DROP_DOWN_LIST_DATA);
// TASK DOCUMENTS UPLOAD
export const postTaskDocuments = data => post(url.POST_TASK_DOC, data);
export const handleShowHideDocAPI = data => post(url.HANDLE_SHOW_HIDE, data);
// UPDATE PARTICIPANT PRO PIC
export const updatePartProPic = data => post(url.UPATE_PART_PRO_PIC, data);
export const participantCalData = data => post(url.PART_CAL_DATA_BY_ID, data);
export const staffCalenderData = data => post(url.STAFF_CAL_DATA_BY_ID, data);
const getAllParticipants = data => post(url.GET_ALL_PARTICIPANTS, data);
// GET ALL STAFF
export const getAllStaff = data => post(url.GET_ALL_STAFF, data);
// POST STAFF DOCS
export const postStaffDocuments = data => post(url.POST_STAFF_DOCS, data);
const getLangTime = () => get(url.GET_LANG_TIME);
// GET SERVICE LIST
const getServices = data => get(url.GET_SERVICE_LIST, data);
// GET AVAILABLE SERVICES
export const getServiceData = data => post(url.GET_SERVICE_DATA, data);
// GET ACTIVE SERVICES
export const getActiveServices = data => post(url.GET_ACTIVE_SERVICES, data);
// ADD NEW ADMIN
// POST DELETE SERVICE
export const postDeleteService = data => post(url.POST_DELETE_SERVICE, data);
// GET STAFF DETAIL BY ID
export const getStaffById = data => post(url.GET_STAFF_BY_ID, data);
// GET SERVICE DETAIL BY ID
export const getServiceDataId = data => post(url.GET_SERVICEID, data);
// UPDATE SERVICES
export const updateServiceData = data => post(url.POST_UPDATE_SERVICE, data);
// POST PARTICIPANT DOCUMENTS
export const postParticipantDoc = ({ data }) => post(url.POST_PARTICIPANT_DOC, data);
// GET PARTICIPANT DOCUMENTS
export const getPartDocouments = data => post(url.GET_PARTICIPANT_DOCS, data);
//GET STAFF DOCS
export const getTaskDocslist = data => post(url.GET_TASK_DOC, data);
// GET STAFF BY EMAIL
const getStaffByEmail = ({ user }) => post(url.GET_STAFF_BY_EMAIL, user);
// DELETE PARTICIPANT
const postDeleteUser = val => post(url.DELETE_PARTICIPANT, val);
// DELETE Staff
export const deleteStaff = val => post(url.DELETE_STAFF, val);
// ADD NEW PARTICIPANT
const postNewParticipant = ({ user }) => post(url.POST_ADD_PARTICIPANT, user);
// UPDATE PARTICIPANT
export const updateParticipant = ({ user }) => post(url.POST_UPDATE_PARTICIPANT, user);
// POST NEW Staff
const addEmployee = user => post(url.POST_ADD_STAFF, user);
// POST NEW Staff
export const postUpdateStaff = user => post(url.POST_UPDATE_STAFF, user);
// GET PARTICIPANT DETAILS
const getParticipantDetail = projectId => post(url.GET_PARTICIPANT_DETAIL, projectId);
// POST SERVICES
const postServiceList = data => post(url.POST_SERVICE_DATA, data);
// get Events
export const getTaskList = data => post(url.GET_TASK_LIST, data);
export const getExportTaskData = data => post(url.TASK_EXPORT_DATA, data);
// FOR CALENDER

// get Events
export const getEvents = data => post(url.GET_EVENTS, data);
export const getEventsList = data => post(url.GET_EVENTS_LIST, data);
// add Events
export const addNewEvent = event => post(url.ADD_NEW_EVENT, event);
// delete Event
export const deleteEvent = event => post(url.DELETE_EVENT, event);
// GET TASK DETAILS BY ID
export const getTaskDetails = data => post(url.GET_TASK_DETAILS, data);
// GET TASK DETAILS BY ID
export const updateEvent = async data => post(url.UPDATE_EVENT, data);
// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};
//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};
// Register Method
const postFakeRegister = data => post(url.POST_FAKE_REGISTER, data);
// Login Method
// const postFakeLogin = data => post(url.POST_FAKE_LOGIN, data)
const postFakeLogin = data => post(url.LOGIN_API, data);
// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);
// Register Method
const postJwtRegister = (url, data) => post(url, data);
// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);
// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);
// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);
// get Products
export const getProducts = () => get(url.GET_PRODUCTS);

// gt Product detail
export const getProductDetail = id => get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } });
// get Categories
export const getCategories = () => get(url.GET_CATEGORIES);
// get chats
export const getChats = () => get(url.GET_CHATS);
// get groups
export const getGroups = () => get(url.GET_GROUPS);
// get Contacts
export const getContacts = () => get(url.GET_CONTACTS);
// get messages
export const getMessages = (roomId = "") => get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } });
// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message);
// get orders
export const getOrders = () => get(url.GET_ORDERS);
// add order
export const addNewOrder = order => post(url.ADD_NEW_ORDER, order);
// update order
export const updateOrder = order => put(url.UPDATE_ORDER, order);
// delete order
export const deleteOrder = order => del(url.DELETE_ORDER, { headers: { order } });
// get cart data
export const getCartData = () => get(url.GET_CART_DATA);
// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS);
// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer);
// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer);
// delete CUSTOMER
export const deleteCustomer = customer => del(url.DELETE_CUSTOMER, { headers: { customer } });
// get shops
export const getShops = () => get(url.GET_SHOPS);
// get wallet
export const getWallet = () => get(url.GET_WALLET);

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS);

// get project
export const getProjects = () => get(url.GET_PROJECTS);

// get project details
export const getProjectsDetails = id => get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } });

// get tasks
export const getTasks = () => get(url.GET_TASKS);

// get contacts
export const getUsers = () => get(url.GET_USERS);

// add user
export const addNewUser = user => post(url.ADD_NEW_USER, user);

// update user
export const updateUser = user => put(url.UPDATE_USER, user);

// delete user
export const deleteUser = user => del(url.DELETE_USER, { headers: { user } });

/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project);

// update user
export const updateProject = project => put(url.UPDATE_PROJECT, project);

// delete user
export const deleteProject = project => del(url.DELETE_PROJECT, { headers: { project } });

export const getUserProfile = () => get(url.GET_USER_PROFILE);

// add inboxmail
export const addNewInboxMail = inboxmail => post(url.ADD_NEW_INBOX_MAIL, inboxmail);

// delete inboxmail
export const deleteInboxMail = inboxmail => del(url.DELETE_INBOX_MAIL, { headers: { inboxmail } });

// get starredmail

// get importantmail
export const getImportantMails = () => get(url.GET_IMPORTANT_MAILS);

// get sent mail
export const getSentMails = () => get(url.GET_SENT_MAILS);

// get trash mail
export const getTrashMails = () => get(url.GET_TRASH_MAILS);

// get starredmail
export const getDraftMails = () => get(url.GET_DRAFT_MAILS);

// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA);
export const getYearlyData = () => get(url.GET_YEARLY_DATA);
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA);

export const topSellingData = month => get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } });

export const getEarningChartsData = month => get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } });

const getProductComents = () => get(url.GET_PRODUCT_COMMENTS);

const onLikeComment = (commentId, productId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, {
    params: { commentId, productId },
  });
};
const onLikeReply = (commentId, productId, replyId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, {
    params: { commentId, productId, replyId },
  });
};

const onAddReply = (commentId, productId, replyText) => {
  return post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, {
    params: { commentId, productId, replyText },
  });
};

const onAddComment = (productId, commentText) => {
  return post(`${url.ON_ADD_COMMENT}/${productId}`, {
    params: { productId, commentText },
  });
};

export {
  postServiceList,
  getLangTime,
  postDeleteUser,
  getParticipantDetail,
  postNewParticipant,
  getStaffByEmail,
  getAllParticipants,
  addEmployee,
  getServices,
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  getProductComents,
  onLikeComment,
  onLikeReply,
  onAddReply,
  onAddComment,
};
